'use strict';

var ChartSponsorForecast = function ChartSponsorForecast(AbstractChart, chartGroups, chartSimpleBars, chartXAxis, chartYAxis, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);

    // chart components
    var groups = chartGroups('d1', formatters.tooltipFormatter, false);
    var simpleBars = chartSimpleBars('m1');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    this.render = function (data, range) {
      this.initChart(data, range, chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForDataGroup([yAxisLeft, groups, simpleBars, xAxis]);
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.withMetric = function (metric) {
      yAxisLeft.label(metric);
      return this;
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartSponsorForecast.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants'];
module.exports = ChartSponsorForecast;